import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';

export interface UsernameAvailabilityResponse extends BackendResponse {
  username: string;
  normalized: string;
  valid: boolean;
  available: boolean;
  reason:
    | 'empty'
    | 'too_short'
    | 'too_long'
    | 'invalid_format'
    | 'taken'
    | null;
  message?: string;
  suggestions: string[];
  rules: {
    min: number;
    max: number;
    allowed: 'letters_numbers_underscore';
  };
}

export function useUsernameAvailability(username: string, enabled: boolean) {
  return useQuery({
    queryKey: ['auth', 'username-availability', username],
    queryFn: () => checkUsernameAvailability(username),
    enabled,
    retry: false,
    staleTime: 15000,
  });
}

function checkUsernameAvailability(
  username: string,
): Promise<UsernameAvailabilityResponse> {
  return apiClient
    .get<UsernameAvailabilityResponse>('auth/username/check', {
      params: {username},
    })
    .then(response => response.data);
}
